import React, { useState } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { KeyboardArrowDown, ChevronLeft, ChevronRight, CalendarMonth } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { CALENDAR_VIEW_TYPES } from '../../../shared/appConstants';
import { DATE_DISPLAY_LABELS } from '../../../shared/appConstants';
import CalendarSettings from './CalendarSettings';
import { CalendarColorLegend } from './calendarColorUtils';
import './CalendarView.scss';

const CalendarHeader = ({
  monthYear,
  weekRange,
  viewType,
  onViewTypeChange,
  onDatePickerOpen,
  onWeekNavigate,
  showWeekRange,
  colorCodeOption,
  onColorCodeChange,
  tasks = [],
  dateRange
}) => {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState('Month');

  const handleTabChange = (tab, type) => {
    setSelectedTab(tab);
    onViewTypeChange(type);
  };

  // Sync selectedTab with viewType changes from parent
  React.useEffect(() => {
    if (viewType === CALENDAR_VIEW_TYPES.MONTH) setSelectedTab('Month');
    else if (viewType === CALENDAR_VIEW_TYPES.WEEK) setSelectedTab('Week');
    else if (viewType === CALENDAR_VIEW_TYPES.CUSTOM) setSelectedTab('Custom');
  }, [viewType]);

  const headerLabel = viewType === CALENDAR_VIEW_TYPES.WEEK
    ? `${DATE_DISPLAY_LABELS.WEEK} (${monthYear})`
    : viewType === CALENDAR_VIEW_TYPES.MONTH
      ? `${DATE_DISPLAY_LABELS.MONTH} (${monthYear})`
      : monthYear;

  const showCalendarIcon = true;

  return (
    <Box className="calendar-header">
      <Box className="calendar-header-inner">
        <Box className="calendar-header-left">
          <Typography 
            className="calendar-month-year"
            onClick={(event) => onDatePickerOpen?.(event)}
          >
            <span className="calendar-month-year-content">
              <span className={`calendar-month-year-label calendar-month-year-label-${viewType}`}>
                {headerLabel}
              </span>
              {showCalendarIcon ? (
                <CalendarMonth className="calendar-calendar-icon" />
              ) : (
                <KeyboardArrowDown className="calendar-dropdown-icon" />
              )}
            </span>
          </Typography>
          <Box className="week-nav-buttons">
            <IconButton onClick={() => onWeekNavigate(-1)} size="small">
              <ChevronLeft />
            </IconButton>
            <IconButton onClick={() => onWeekNavigate(1)} size="small">
              <ChevronRight />
            </IconButton>
          </Box>
          {showWeekRange && weekRange && (
            <Typography className="calendar-month-year">
              {weekRange}
            </Typography>
          )}
        </Box>

        <Box className="calendar-header-right">
          {colorCodeOption && <CalendarColorLegend colorCodeOption={colorCodeOption} tasks={tasks} dateRange={dateRange} />}
          <Box className="calendar-view-tabs">
            <Box 
              className={`calendar-view-tab ${selectedTab === 'Month' ? 'calendar-view-tab-active' : ''}`}
              onClick={() => handleTabChange('Month', CALENDAR_VIEW_TYPES.MONTH)}
            >
              {t('calendar.month')}
            </Box>
            <Box 
              className={`calendar-view-tab ${selectedTab === 'Week' ? 'calendar-view-tab-active' : ''}`}
              onClick={() => handleTabChange('Week', CALENDAR_VIEW_TYPES.WEEK)}
            >
              {t('calendar.week')}
            </Box>
            <Box 
              className={`calendar-view-tab ${selectedTab === 'Custom' ? 'calendar-view-tab-active' : ''}`}
              onClick={() => handleTabChange('Custom', CALENDAR_VIEW_TYPES.CUSTOM)}
            >
              {t('calendar.custom')}
            </Box>
          </Box>
          <CalendarSettings 
            selectedOption={colorCodeOption}
            onOptionChange={onColorCodeChange}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default CalendarHeader;
